import React from 'react';

import { Tag, Tooltip } from 'antd';
import { useIntl } from 'react-intl';

import type { SupervisorClosureTagProps } from './SupervisorClosureTag.types';

/**
 * Marks a completed work order that a supervisor closed on behalf of its assignees (ADR 0002),
 * so a completed state next to progress below 100% reads as intended.
 */
const SupervisorClosureTag = ({ reason }: SupervisorClosureTagProps) => {
  const intl = useIntl();

  return (
    <Tooltip title={reason}>
      <Tag color="cyan" className="gx-mr-0">
        {intl.formatMessage({ id: 'work.order.supervisorClose.tag' })}
      </Tag>
    </Tooltip>
  );
};

export default React.memo(SupervisorClosureTag);
